const initialState = {
  plansLoading: false,

  planContext: {},
  studentPlans: {},

  allStudentsSelected: false,
  selectedStudents: [],
  deselectedStudents: [],

  guardiansCount: 0,
  isBusyRetrievingGuardiansCount: false,

  planFilters: {
    search: '',
    sortField: 'last_modified',
    sortOrder: '-',
    year: undefined,
    planStatus: [],
    page: 1,
    pageSize: 10,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'SET_BUSY':
      return {
        ...state,
        plansLoading: action.mode,
      };
    case 'POPULATE_PLAN_LIST_CONTEXT':
      return {
        ...state,
        planContext: {
          ...action.planContext,
        },
      };
    case 'POPULATE_STUDENT_PLANS':
      return {
        ...state,
        studentPlans: {
          ...state.studentPlans,
          ...action.studentPlans,
        },
      };
    case 'POPULATE_STUDENT_PLANS_SUMMARY':
      return {
        ...state,
        studentPlans: {
          ...state.studentPlans,
          ...action.data,
        },
      };
    case 'SET_GRID_PAGE':
      return {
        ...state,
        planFilters: {
          ...state.planFilters,
          page: action.page,
        },
      };
    case 'SET_ROWS_PER_PAGE':
      return {
        ...state,
        planFilters: {
          ...state.planFilters,
          pageSize: action.pageSize,
        },
      };
    case 'SET_SORTING_COLUMN': {
      const currentOrderingDirection = state.planFilters.sortOrder;
      const reverseOrder = currentOrderingDirection === '' ? '-' : '';
      const shouldReverseDirection =
        state.planFilters.sortField === action.sortField;
      return {
        ...state,
        planFilters: {
          ...state.planFilters,
          sortField: action.sortField,
          sortOrder: shouldReverseDirection
            ? reverseOrder
            : currentOrderingDirection,
        },
      };
    }
    case 'SET_PLAN_FILTER':
      return {
        ...state,
        planFilters: {
          ...state.planFilters,
          ...action.filter,
        },
      };
    case 'REMOVE_ACTIVE_FILTER': {
      const removeFromList = Array.isArray(
        state.planFilters[action.filterName],
      );
      return {
        ...state,
        planFilters: {
          ...state.planFilters,
          [action.filterName]: removeFromList
            ? state.planFilters[action.filterName].filter(entry => {
                const value = typeof entry === 'object' ? entry.value : entry;
                return value !== action.filterValue;
              })
            : undefined,
        },
      };
    }
    case 'TOGGLE_ALL_STUDENTS_SELECTION':
      return {
        ...state,
        allStudentsSelected: [true, false].includes(action.status)
          ? action.status
          : !state.allStudentsSelected,
        selectedStudents: [],
        deselectedStudents: [],
      };
    case 'TOGGLE_SINGLE_STUDENT_SELECTION': {
      const newSelection = state.selectedStudents.includes(action.studentId)
        ? state.selectedStudents.filter(id => id !== action.studentId)
        : [...state.selectedStudents, action.studentId];
      return {
        ...state,
        selectedStudents: newSelection,
      };
    }
    case 'COURSE_LISTING_BUSY_RETRIEVING_GUARDIANS_COUNT':
      return {
        ...state,
        isBusyRetrievingGuardiansCount: action.mode,
      };
    case 'COURSE_LISTING_MANAGER_GUARDIANS_COUNT':
      return {
        ...state,
        guardiansCount: action.guardiansCount,
      };
    default:
      return state;
  }
};
